import _objectWithoutProperties from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["throwError"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import axios from 'axios';
import { get } from 'lodash';
import { ResponseCode } from 'data/api/response-codes';
import { isAxiosError, isAxiosResponse } from 'data/utils/axios';
import { serverSide } from 'libs/utils/environment';
import { isObject } from 'libs/utils/object';

class ApiClient {
  constructor(config, interceptors) {
    _defineProperty(this, "axios", void 0);

    this.axios = axios.create(config);
    interceptors === null || interceptors === void 0 ? void 0 : interceptors.forEach(interceptor => interceptor(this.axios));
  }

  get(url, config) {
    return this.request('get', url, config);
  }

  put(url, data, config) {
    return this.request('put', url, config, data);
  }

  patch(url, data, config) {
    return this.request('patch', url, config, data);
  }

  post(url, data, config) {
    return this.request('post', url, config, data);
  }

  delete(url, config) {
    return this.request('delete', url, config);
  }

  request(method, url) {
    let _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    let data = arguments.length > 3 ? arguments[3] : undefined;

    let {
      throwError
    } = _ref,
        config = _objectWithoutProperties(_ref, _excluded);

    this.validateRequest("".concat(method || '', ": ").concat(url));
    return this.axios.request(_objectSpread(_objectSpread({}, config), {}, {
      method,
      url,
      data
    })).then(this.returnAxiosData, throwError ? undefined : this.parseException);
  } // eslint-disable-next-line class-methods-use-this


  returnAxiosData(response) {
    return response.data;
  } // eslint-disable-next-line class-methods-use-this


  parseException(exception) {
    const errorResponse = {
      status: null,
      code: get(exception, 'code', ResponseCode.JsError),
      message: get(exception, 'message', ''),
      errors: [],
      payload: undefined
    }; // Backend errors

    if (isObject(exception) && isAxiosResponse(exception.response)) {
      var _data$code;

      const {
        status,
        data
      } = exception.response;
      errorResponse.status = status;
      errorResponse.code = (_data$code = data.code) !== null && _data$code !== void 0 ? _data$code : ResponseCode.JsError;
      if (data.message) errorResponse.message = data.message;
      errorResponse.errors = data.errors || [];
      errorResponse.payload = data.payload;
      return errorResponse;
    } // Generic HTTP errors


    if (isAxiosError(exception) && exception.response) {
      const {
        status,
        statusText
      } = exception.response;
      errorResponse.code = ResponseCode.HttpError;
      errorResponse.status = status;
      errorResponse.message = statusText;
      return errorResponse;
    } // Network or Javascript error


    return errorResponse;
  } // eslint-disable-next-line class-methods-use-this


  validateRequest(call) {
    if (serverSide) throw new Error("ApiClient can only be used on the client side (".concat(call, ")"));
  }

}

export default ApiClient;